"use client";

import { useCallback } from "react";
import { useTutorial } from "@/context/TutorialContext";

export function ResourcesGlobalSearchTrigger() {
  const { openSearch } = useTutorial();

  const handleOpen = useCallback(() => {
    if (openSearch) {
      openSearch();
      return;
    }
    const headerBtn = document.querySelector<HTMLButtonElement>(
      "[data-tour=\"header-search\"]",
    );
    headerBtn?.click();
  }, [openSearch]);

  return (
    <div className="mx-auto mt-8 w-full max-w-2xl">
      <button
        type="button"
        onClick={handleOpen}
        className="relative w-full rounded-2xl border border-black/10 bg-white py-4 pl-14 pr-24 text-left text-[15px] shadow-sm outline-none transition-all hover:border-primary/25 hover:shadow-md focus-visible:border-primary/30 focus-visible:ring-2 focus-visible:ring-primary/10 dark:border-white/10 dark:bg-[#1a1f25] dark:hover:border-primary/30 dark:focus-visible:ring-primary/20"
        aria-label="Open site search (Command K)"
      >
        <svg
          className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-[#999] dark:text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden
        >
          <circle cx="11" cy="11" r="8" />
          <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-4.35-4.35" />
        </svg>
        <span className="pointer-events-none text-[#999] dark:text-gray-500">
          Search medications, pages, and more…
        </span>
        <kbd className="pointer-events-none absolute right-5 top-1/2 hidden -translate-y-1/2 rounded border border-black/10 bg-white/90 px-2 py-1 text-[10px] font-medium text-[#666] sm:inline-block dark:border-white/10 dark:bg-white/10 dark:text-gray-400">
          ⌘K
        </kbd>
      </button>
      <p className="mt-2 text-center text-xs text-(--text-secondary)">
        keyboard shortcut{" "}
        <kbd className="rounded border border-black/10 bg-black/4 px-1.5 py-0.5 font-mono text-[10px] dark:border-white/10 dark:bg-white/5">
          ⌘
        </kbd>
        <kbd className="ml-0.5 rounded border border-black/10 bg-black/4 px-1.5 py-0.5 font-mono text-[10px] dark:border-white/10 dark:bg-white/5">
          K
        </kbd>{" "}
        (Mac) or Ctrl+K (Windows).
      </p>
    </div>
  );
}
